import { TFilters } from "../../../../../../components/TableDataGridV2/types"
import { Box, Button, Container, Grid } from "@mui/material"
import DateComIntervalo from "../../../../../../components/DateComIntervalo"
import SelectPlanoContas from "../../../../../../components/SelectsSimpleApiQuery/SelectPlanoContas"
import SelectLojaComPesquisa, { TLoja } from "../../../../../../components/SelectsSimpleApiQuery/SelectLojaComPesquisa"
import FiltroTipoBaixa, { TTipoBaixaFiltros } from "./FiltroTipoBaixa"
import FiltroTipoMovimento, { TTipoMovimento } from "./FiltroTipoMovimento"
import moment from "moment"
import { enqueueSnackbar } from "notistack"
import { Controller, useForm } from "react-hook-form"

export default function PreFiltros({
    filtros,
    onSubmitFilters
}: PreFiltrosProps) {

    const { control, handleSubmit, reset } = useForm<FormValues>({
        defaultValues: {
            ...filtros,
            dateRange: {
                inicial: filtros.data_movimento_inicio,
                final: filtros.data_movimento_fim
            }
        }
    })

    const filtrarObj = (obj: TFilters) => {
        const novoObjeto: TFilters = { ...obj };

        Object.keys(novoObjeto)
            .filter(key => novoObjeto[key] !== undefined && novoObjeto[key] !== null)
            .forEach((key) => {

                if (novoObjeto[key]) {
                    if (key.startsWith('loja')) {
                        novoObjeto.loja_id_contem = novoObjeto[key].map((loja: TLoja) => loja.id)
                        delete novoObjeto[key];
                    }

                    if (key.startsWith('plano_contas')) {
                        novoObjeto.codigo_contabil_contem = [novoObjeto[key].codigo_contabil];
                        if (novoObjeto[key].centro_custo) {
                            novoObjeto.centro_custo_contem = [novoObjeto[key].centro_custo.id]
                        }
                        delete novoObjeto[key];
                    }

                    // Processar filtros de tipo de baixa
                    if (key.includes('tipoBaixa')) {
                        const tipoBaixa: TTipoBaixaFiltros = novoObjeto[key]

                        const selecionados = Object.entries(tipoBaixa)
                            .filter(([, valor]) => valor === "S")
                            .map(([chave]) => tipoBaixaParamsFormatado[chave as keyof typeof tipoBaixaParamsFormatado])
                            .filter(Boolean) as string[]

                        const naoSelecionados = Object.entries(tipoBaixa)
                            .filter(([, valor]) => valor === "N")
                            .map(([chave]) => tipoBaixaParamsFormatado[chave as keyof typeof tipoBaixaParamsFormatado])
                            .filter(Boolean) as string[]

                        if (selecionados.length > 0) {
                            novoObjeto.tipo_baixa_contem = selecionados
                        } else {
                            delete novoObjeto.tipo_baixa_contem
                        }

                        if (naoSelecionados.length > 0) {
                            novoObjeto.tipo_baixa_naocontem = naoSelecionados
                        } else {
                            delete novoObjeto.tipo_baixa_naocontem
                        }

                        delete novoObjeto[key]
                    }

                    if (key === 'tipoMovimento') {
                        const tipoMovimento: TTipoMovimento = novoObjeto[key];
                        const movimentosSelecionados: number[] = [];
                        const movimentosNaoSelecionados: number[] = [];

                        Object.entries(tipoMovimento).forEach(([movimento, valor]) => {
                            if (valor === "S") {
                                movimentosSelecionados.push(Number(movimento));
                            } else if (valor === "N") {
                                movimentosNaoSelecionados.push(Number(movimento));
                            }
                        });

                        if (movimentosSelecionados.length > 0) {
                            novoObjeto.tipo_movimento_contem = movimentosSelecionados;
                        } else {
                            delete novoObjeto.tipo_movimento_contem;
                        }

                        if (movimentosNaoSelecionados.length > 0) {
                            novoObjeto.tipo_movimento_naocontem = movimentosNaoSelecionados;
                        } else {
                            delete novoObjeto.tipo_movimento_naocontem;
                        }

                        delete novoObjeto[key];
                    }
                }
                delete novoObjeto[key];
            });
        return novoObjeto;
    };

    const onSubmit = (values: FormValues) => {
        const internFilters: any = {
            ...values,
            data_movimento_inicio: values.dateRange?.inicial,
            data_movimento_fim: values.dateRange?.final
        }
        delete internFilters.dateRange

        if (!internFilters['data_movimento_inicio'] || !internFilters['data_movimento_fim']) {
            enqueueSnackbar("É necessário informar as datas de início e fim", { variant: "warning" });
            return;
        }

        const dataInicio = moment(internFilters['data_movimento_inicio'])
        const dataFim = moment(internFilters['data_movimento_fim'])
        if (dataInicio.isAfter(dataFim)) {
            return enqueueSnackbar("A data inicial não pode ser maior que a data final.", { variant: "warning" });
        }

        const formatValue = filtrarObj(internFilters)

        formatValue['data_movimento_inicio'] = dataInicio.format("YYYY-MM-DD")
        formatValue['data_movimento_fim'] = dataFim.format("YYYY-MM-DD")
        const cleanedValue = Object.keys(formatValue).reduce((acc, key) => {
            const value = formatValue[key];
            if (value !== undefined && value !== null &&
                !(Array.isArray(value) && value.length === 0)) {
                acc[key] = value;
            }
            return acc;
        }, {} as any);

        onSubmitFilters(cleanedValue)
    }

    return (
        <Container maxWidth="md" sx={{ pb: 2 }}>
            <Grid container spacing={2} py={2}>
                <Grid size={{ xs: 12, md: 6 }}>
                    <Controller
                        name="dateRange"
                        control={control}
                        rules={{ validate: (v) => (v && v.inicial && v.final) || 'Campo obrigatório' }}
                        render={({ field, fieldState: { invalid, error } }) => (
                            <DateComIntervalo
                                data={{
                                    inicial: field.value?.inicial ? (moment.isMoment(field.value.inicial) ? field.value.inicial : moment(field.value.inicial)) : null,
                                    final: field.value?.final ? (moment.isMoment(field.value.final) ? field.value.final : moment(field.value.final)) : null
                                }}
                                onChangeData={(data) => {
                                    field.onChange(data)
                                }}
                                datePickerView={['year', 'month', 'day']}
                                formatString="DD/MM/YYYY"
                                labelInput="Data movimentação *"
                                error={invalid}
                                helperText={error?.message}
                            />
                        )}
                    />
                </Grid>

                <Grid size={{ xs: 12, md: 6 }}>
                    <Controller
                        name="loja"
                        control={control}
                        render={({ field }) => (
                            <SelectLojaComPesquisa
                                value={field.value}
                                onChange={(valor) => field.onChange(valor)}
                                multiple
                            />
                        )}
                    />
                </Grid>

                <Grid size={{ xs: 12, md: 6 }}>
                    <Controller
                        name="plano_contas"
                        control={control}
                        render={({ field }) => (
                            <SelectPlanoContas
                                inputLabel="Conta contábil"
                                value={field.value}
                                onChangeValue={(valor) => field.onChange(valor)}
                                extraParams={{ tipo: "Analítica" }}
                            />
                        )}
                    />
                </Grid>

                <Grid size={{ xs: 12, md: 6 }}>
                    <Controller
                        name="tipoBaixa"
                        control={control}
                        render={({ field }) => (
                            <FiltroTipoBaixa
                                value={field.value}
                                onChange={(valor) => field.onChange(valor)}
                            />
                        )}
                    />
                </Grid>

                <Grid size={{ xs: 12, md: 6 }}>
                    <Controller
                        name="tipoMovimento"
                        control={control}
                        render={({ field }) => (
                            <FiltroTipoMovimento
                                value={field.value}
                                onChange={(valor) => field.onChange(valor)}
                            />
                        )}
                    />
                </Grid>
            </Grid>

            <Box display="flex" gap={2}>
                <Button
                    variant="outlined"
                    onClick={() => {
                        reset({
                            dateRange: { inicial: null, final: null },
                            loja: [],
                            plano_contas: undefined,
                            tipoBaixa: initialFiltersRecebimentoBaixas.tipoBaixa,
                            tipoMovimento: initialFiltersRecebimentoBaixas.tipoMovimento
                        } as Partial<FormValues>)
                    }}
                >
                    Limpar
                </Button>

                <Button variant="contained" onClick={handleSubmit(onSubmit)} sx={{ mr: 1 }}>
                    Pesquisar
                </Button>
            </Box>
        </Container>
    )
}

interface PreFiltrosProps {
    filtros: TFilters,
    onSubmitFilters: (args: TFilters) => void
}

const tipoBaixaParamsFormatado: TBaixaParamFormatado = {
    filiais: "F",
    normal: "N",
    extraCaixa: "E",
    devolucao: "D",
    cancelamento: "C",
    substituicao: "S",
    manual: "U"
}

type TBaixaParamFormatado = {
    [K in keyof TTipoBaixaFiltros]: string
}

type DateRange = { inicial?: string | null, final?: string | null }
type FormValues = TFilters & { dateRange?: DateRange }

export const initialFiltersRecebimentoBaixas = {
    tipoBaixa: {
        filiais: "N",
        normal: "N",
        extraCaixa: "N",
        devolucao: "N",
        cancelamento: "N",
        substituicao: "N"
    },
    tipoMovimento: {
        "6": "N",
        "7": "N",
        "8": "N",
        "9": "N"
    },
    page: 1,
    limit: 25
}